import { z } from 'zod';

import { Entity, Property } from '../decorators';
import { zDate } from '../zod-types';
import transformer from './transformer';

@Entity
export class OrderModel {
  @Property(zDate)
  orderDateTime!: Date;

  @Property(z.string())
  orderReference!: string;

  @Property(z.string())
  vendor!: string;
}

export const OrderTransformer = transformer(OrderModel);

@Entity
export class OrderDetailsModel {
  @Property(z.string())
  code!: string;

  @Property(z.string())
  country!: string;

  @Property(OrderTransformer)
  order!: OrderModel;
}

export const OrderDetailsTransformer = transformer(OrderDetailsModel);

export interface OrderDetailsResponseBack {
  code: string;
  country: string;
  order: {
    orderDateTime: string;
    orderReference: string;
    vendor: string;
  };
}
